module.exports = __webpack_public_path__ + "static/06-111b022ca1e7ea385bbb2a7e781a5b28.jpg";